module.exports = __webpack_public_path__ + "img/lg_ring_g_c_0_0@2x.2578dddc.png";